module.exports = __webpack_public_path__ + "static/media/html5.d1f26ea5.png";


//////////////////
// WEBPACK FOOTER
// ./src/photos/html5.png
// module id = 142
// module chunks = 0